import {
  ADDED,
  TOGGLED,
  DELETED,
  COLORSELECTED,
  COMPLETEALL,
  CLEARCOMPLETED,
  LOADED,
  UPDATE,
} from "./ActionType";
import initialState from "./initialState";

const nextTodoId = (todos) => {
  const maxId = todos.reduce((maxId, todo) => Math.max(todo.id, maxId), -1);
  return maxId + 1;
};

const todoReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADED:
      return action.payload;
    case ADDED:
      return [
        ...state,
        {
          id: nextTodoId(state),
          text: action.payload,
        },
      ];

    case TOGGLED:
      return state.map((todo) => {
        if (todo.id !== action.payload) {
          return todo;
        }
        return {
          ...todo,
          completed: !todo.completed,
        };
      });
    case DELETED:
      return state.filter((todo) => todo.id !== action.payload);
    case COLORSELECTED:
      const { color, todoId } = action.payload;
      return state.map((todo) => {
        if (todo.id !== todoId) {
          return todo;
        }
        return {
          ...todo,
          color,
        };
      });
    case COMPLETEALL:
      return state.map((todo) => {
        return {
          ...todo,
          completed: true,
        };
      });
    case UPDATE:
      return state.map((todo) => {
        if (todo.id !== action.payload.id) {
          return todo;
        }
        return {
          ...todo,
          text: action.payload.text,
        };
      });
    case CLEARCOMPLETED:
      return state.filter((todo) => !todo.completed);

    default:
      return state;
  }
};
export default todoReducer;
